import React from 'react';

function ProjectorAcknowlegingTxt() {
  return (
    <span>
      By continuing , you acknowledge that you have read and understood the
      &nbsp;
      <a
        style={{ color: '#5AA5EF ' }}
        target="_blank"
        rel="noreferrer"
        href="http://app.projectorstream.com.s3-website-us-west-2.amazonaws.com/settings/terms-of-use"
      >
        Terms of Use
{' '}
      </a>
      ,&nbsp;
      <a
        style={{ color: '#5AA5EF ' }}
        target="_blank"
        rel="noreferrer"
        href="https://projector.app/privacy"
      >
        Privacy Policy
{' '}
      </a>
{' '}
      &nbsp;and &nbsp;
      <a
        style={{ color: '#5AA5EF ' }}
        target="_blank"
        rel="noreferrer"
        href="http://app.projectorstream.com.s3-website-us-west-2.amazonaws.com/settings/terms-of-use "
      >
        Subscriber Agreement.
      </a>
    </span>
  );
}

export default ProjectorAcknowlegingTxt;
